import { ed, STACK_GRAYS } from "./tokens";

/**
 * A word-sized 100% bar for table cells: the largest part in ink, the rest
 * in grays. For mix columns (issue types, work categories).
 */
export function MixBar({
  parts,
  width = 56,
}: {
  parts: Array<{ label: string; value: number }>;
  width?: number;
}) {
  const total = parts.reduce((s, p) => s + p.value, 0);
  if (total === 0) return null;
  const sorted = [...parts].sort((a, b) => b.value - a.value);
  const shades = [ed.ink, ...STACK_GRAYS];
  const widths = sorted.map((p) => (p.value / total) * width);
  const offsets = widths.map((_, i) =>
    widths.slice(0, i).reduce((s, w) => s + w, 0),
  );
  return (
    <svg
      width={width}
      height={8}
      viewBox={`0 0 ${width} 8`}
      aria-hidden
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      {sorted.map((p, i) => {
        const w = widths[i] ?? 0;
        return (
          <rect
            key={p.label}
            x={offsets[i]}
            y={0}
            width={Math.max(0, w - 0.5)}
            height={8}
            fill={shades[Math.min(i, shades.length - 1)]}
          >
            <title>{`${p.label}: ${p.value}`}</title>
          </rect>
        );
      })}
    </svg>
  );
}
